/* ==========================================
   ELLYRA PREMIUM VIDEO REELS
   PART 1
========================================== */

document.addEventListener("DOMContentLoaded", function () {

const slider = document.querySelector(".ellyra-slider-track");

if (!slider) return;

const videos = slider.querySelectorAll("video");

const prevBtn = document.querySelector(".ellyra-prev");
const nextBtn = document.querySelector(".ellyra-next");

function stopAllVideos(){

videos.forEach(video=>{

video.pause();

video.currentTime = 0;

});

}

const observer = new IntersectionObserver((entries)=>{

entries.forEach(entry=>{

const video = entry.target;

if(entry.isIntersecting){

stopAllVideos();

video.muted = true;

const promise = video.play();

if(promise !== undefined){

promise.catch(()=>{});

}

}else{

video.pause();

}

});

},{
threshold:0.70
});

videos.forEach(video=>{

observer.observe(video);

});
/* ==========================================
   ELLYRA PREMIUM VIDEO REELS
   PART 2
========================================== */

// Desktop navigation

if(prevBtn){

prevBtn.addEventListener("click",function(){

slider.scrollBy({

left:-350,

behavior:"smooth"

});

});

}

if(nextBtn){

nextBtn.addEventListener("click",function(){

slider.scrollBy({

left:350,

behavior:"smooth"

});

});

}

// Tap video to play/pause + mute/unmute

videos.forEach(video=>{

video.addEventListener("click",function(){

if(video.paused){

video.muted=false;

video.play();

}else{

video.pause();

}

});

video.addEventListener("dblclick",function(){

video.muted=!video.muted;

});

});

// Keyboard support

document.addEventListener("keydown",function(e){

if(e.key==="ArrowRight"){

slider.scrollBy({

left:350,

behavior:"smooth"

});

}

if(e.key==="ArrowLeft"){

slider.scrollBy({

left:-350,

behavior:"smooth"

});

}

});
/* ==========================================
   ELLYRA PREMIUM VIDEO REELS
   PART 3
========================================== */

// Pause videos when page is hidden

document.addEventListener("visibilitychange",function(){

if(document.hidden){

videos.forEach(video=>{

video.pause();

});

}else{

const active=document.querySelector(".ellyra-video");

if(active){

active.play().catch(()=>{});

}

}

});

// Lazy loading

videos.forEach(video=>{

video.setAttribute("preload","metadata");

});

// Mobile swipe momentum

let touchStartY=0;

slider.addEventListener("touchstart",function(e){

touchStartY=e.touches[0].clientY;

});

slider.addEventListener("touchend",function(e){

if(window.innerWidth>768) return;

const touchEndY=e.changedTouches[0].clientY;

const difference=touchStartY-touchEndY;

if(Math.abs(difference)<60) return;

if(difference>0){

slider.scrollBy({

top:window.innerHeight,

behavior:"smooth"

});

}else{

slider.scrollBy({

top:-window.innerHeight,

behavior:"smooth"

});

}

});

// Keep videos muted until user interacts

videos.forEach(video=>{

video.muted=true;

});

// End DOM Ready

});